import { defaultIconAssignments as e, goStudentLearning as t } from "./consts.js";
const r = {
  free: e,
  premium: e,
  plurall: e,
  goStudentLearning: t
};
export {
  r as themes
};
